import { useCallback, useState } from 'react';

import { submitTicketDetails, uploadTicketAttachments } from '../services/ticket-api';

export const useTicketSubmit = eid => {
  const [submitting, setSubmitting] = useState(false);

  const submitTicket = useCallback(
    async (body, files) => {
      setSubmitting(true);

      try {
        const attachmentIds = await uploadTicketAttachments(eid, files ?? []);
        const bodyWithAttachments = attachmentIds.length
          ? { ...body, attachmentIds }
          : body;
        const result = await submitTicketDetails(eid, bodyWithAttachments);

        return result ?? {};
      } finally {
        setSubmitting(false);
      }
    },
    [eid]
  );

  return { submitTicket, submitting };
};
